import { styled } from "styled-components";

const Bar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const Button = styled.button`
  width: 78px;
  height: 36px;
  border-radius: 5px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  cursor: pointer;
  text-align: center;
  font-family: "Noto Sans KR";
  font-size: 15px;
  font-weight: 400;
  background-color: ${(props) => (props.$active ? "#0079e0" : "#ffffff")};
  color: ${(props) => (props.$active ? "#ffffff" : "#000000")};
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
`;

/**
 * 조건 검색의 검색 / 초기화 버튼.
 *
 * @param onSearch     검색 클릭
 * @param onReset      초기화 클릭
 * @param searchActive 검색 버튼 강조(필터에 입력값이 있을 때 true)
 */
export function FilterActions({
  onSearch,
  onReset,
  searchActive = false,
  searchLabel = "검색",
  resetLabel = "초기화",
}) {
  return (
    <Bar>
      <Button type="button" $active={searchActive} onClick={onSearch}>
        {searchLabel}
      </Button>
      <Button type="button" onClick={onReset}>
        {resetLabel}
      </Button>
    </Bar>
  );
}

export default FilterActions;
